import { Award } from "@hubcapp/types";
import { Box, Typography, colors, makeStyles } from "@material-ui/core";
import { getAwardTitle } from "../helpers";
import React from "react";

const useStyles = makeStyles(theme => ({
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 0),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${colors.grey[200]}`,
    },
  },
  subTitle: {},
}));

interface Props {
  award: Award;
  supportersCount: number;
}

const AwardRow: React.FC<Props> = ({ award, supportersCount }) => {
  const classes = useStyles();

  return (
    <Box className={classes.row}>
      <Typography variant="h3" color="textPrimary" className={classes.subTitle}>
        {getAwardTitle(award)}
      </Typography>
      <Typography
        variant="body2"
        color={supportersCount > 0 ? "textPrimary" : "error"}
      >
        {supportersCount} supporter{supportersCount > 1 ? "s" : ""}
      </Typography>
    </Box>
  );
};
export default AwardRow;
